<template>
  <v-dialog
    v-model="showDialog"
    :fullscreen="$vuetify.breakpoint.mobile"
    max-width="40%"
    eager
    transform-origin="bottom center"
  >
    <v-card class="d-flex flex-column">
      <v-toolbar
        dark
        color="primary"
        class="flex-grow-0"
      >
        <v-toolbar-title>{{ title|trans }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          dark
          @click="showDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4 flex-grow-1">
        <bkf-form-simple
          v-if="show"
          ref="formSimple"
          :form-url="formUrl"
          :action-url="actionUrl"
          :context="context"
          :entry="entry"
          :options="options"
          :submit-text="submitText"
          :request-method="requestMethod"
          @fetching="onFetching"
          @fetched="onFetched"
          @fetchError="onFetchError"
          @submitting="onSubmitting"
          @submitted="onSubmitted"
          @submitError="onSubmitError"
          @validate-error="onValidateError"
        />
      </v-card-text>
      <v-spacer />
      <v-divider />

      <!--      <v-card-actions>-->
      <!--        <v-spacer />-->
      <!--        <v-btn-->
      <!--          tile-->
      <!--          color="primary"-->
      <!--          :loading="fetching || submitting"-->
      <!--          @click="submit"-->
      <!--        >-->
      <!--          {{ 'v2.fm2.dialog.update'|trans }}-->
      <!--        </v-btn>-->
      <!--      </v-card-actions>-->
    </v-card>
  </v-dialog>
</template>

<script>
import BkfFormSimple from '../../../libs/forms/Form/Form.vue';

// States as events
const events = {
  fetching: 'fetching',
  fetched: 'fetched',
  fetchError: 'fetchError',
  submitting: 'updating',
  submitted: 'updated',
  submitError: 'updateError',
  validateError: 'validateError',
};

// Component
export default {
  components: {
    BkfFormSimple,
  },
  props: {
    requestMethod: {
      type: String,
      required: false,
      default: 'put',
    },
    submitText: {
      type: String,
      required: false,
      default: 'dialog.update',
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    formUrl: {
      type: String,
      required: false,
      default: null,
    },
    actionUrl: {
      type: String,
      required: false,
      default: null,
    },
    context: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    show: false,
    showDialog: false,
    fetching: false,
    submitting: false,
    entry: null,
    options: {},
  }),
  watch: {
    showDialog(newValue) {
      if (newValue === false) {
        this.onClose();
      }
    },
  },
  methods: {
    open(entry, options = {}) {
      this.fetching = false;
      this.submitting = false;
      this.show = true;
      this.entry = entry || null;
      this.options = options;
    },
    submit() {
      this.$refs.form.submit();
    },
    async onClose() {
      this.$emit('close');
      await this.$sleep(500);
      this.show = false;
    },
    onFetching() {
      this.fetching = true;
      this.$emit(events.fetching);
    },
    onFetched() {
      this.fetching = false;
      this.$emit(events.fetched);
      this.showDialog = true;
    },
    onFetchError(payload) {
      this.fetching = false;
      this.show = false;
      this.$emit(events.fetchError, payload);
    },
    onSubmitting() {
      this.submitting = true;
    },
    async onSubmitted(payload) {
      this.$emit(events.submitted, payload);
      this.showDialog = false;
    },
    async onSubmitError(payload) {
      this.$emit(events.submitError, payload);
      this.showDialog = false;
    },
    onValidateError() {
      this.submitting = false;
      this.$emit(events.validateError);
    },
  },
};
</script>
